module.exports = __webpack_public_path__ + "d8ab813483006d6bce3470bc966d6865.MP3";